import styles from './Settings.module.scss';

const Settings = () => {
    return (
        <section className={styles.root}>
            <h1 className={styles.title}>settings</h1>
        </section>
    );
};

export default Settings;
